function collectionDescription(){
    const descriptionWrapper = document.querySelector('.js-catalog__description-wrapper');
    if(descriptionWrapper){
        let descriptionBlock = descriptionWrapper.querySelector('.catalog__description'),
            showMoreBtn = descriptionWrapper.querySelector('.catalog__description-show_more'),
            maxHeight = parseInt(descriptionBlock.dataset.desktopHeight);
        if(window.matchMedia('(max-width: 767px)').matches){
            maxHeight = parseInt(descriptionBlock.dataset.mobileHeight);
        }
        if(descriptionBlock.offsetHeight < maxHeight){
            showMoreBtn.classList.add('hidden');
        }else{
            showMoreBtn.classList.remove('hidden');
            descriptionBlock.style.height = maxHeight + 'px'
            descriptionBlock.classList.add('collapsed');
        }

    }
}
function collectionDescriptionBtn(){
    const showMoreBtn = document.querySelector('.js-catalog__description-wrapper .catalog__description-show_more');
    if(showMoreBtn){
        showMoreBtn.addEventListener('click',function (){
            let descriptionBlock = this.closest('.js-catalog__description-wrapper').querySelector('.catalog__description'),
                currentText = this.innerText,
                maxHeight = parseInt(descriptionBlock.dataset.desktopHeight);
            if(window.matchMedia('(max-width: 767px)').matches){
                maxHeight = parseInt(descriptionBlock.dataset.mobileHeight);
            }
            this.innerText = this.dataset.alternativeText;
            this.dataset.alternativeText = currentText;
            if(descriptionBlock.classList.contains('collapsed')){
                descriptionBlock.style.height = descriptionBlock.scrollHeight + 'px';
                descriptionBlock.classList.remove('collapsed');
            }else{
                descriptionBlock.style.height = maxHeight + 'px'
                descriptionBlock.classList.add('collapsed');
            }
        });
    }
}
collectionDescription();
collectionDescriptionBtn();
window.addEventListener('resize',function (){
    collectionDescription();
})
